import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import * as amplitude from '@amplitude/analytics-browser';

import { Accordion } from '@unified-checkout/design-system';

import type { IAdvancedOptionsProps } from '@app/dashboard/types/innerLayout/payment_links/single_quick_link';
import {
  ADVANCED_OPTIONS_INITIAL_VALUES,
  SINGLE_PL_SECTIONS_DIMENSIONS,
} from '@app/dashboard/constants/payment-links/single-payments';
import {
  SINGLE_PAYMENT_LINKS_EVENTS,
  SINGLE_PAYMENT_LINKS_EVENTS_PARAMS,
  SINGLE_PAYMENT_LINKS_EVENTS_VALUES,
} from '@app/dashboard/constants/tracking_events/payment_links/single';

import { SectionLoader } from '../../../Loader';
import ImageUploader from './components/ImageUploader';
import Description from './components/Description';
import ReferenceId from './components/ReferenceId';

import styles from './advanced-options.module.scss';

const AdvancedOptions = ({
  fields,
  setFields,
  fullPageStatus,
}: IAdvancedOptionsProps) => {
  const { t } = useTranslation();

  const handleAccordionToggle = (isOpen: boolean) => {
    amplitude.track(SINGLE_PAYMENT_LINKS_EVENTS.ADVANCED_OPTIONS_EXPANDED, {
      [SINGLE_PAYMENT_LINKS_EVENTS_PARAMS.SECTION]:
        SINGLE_PAYMENT_LINKS_EVENTS_VALUES.ADVANCED_OPTIONS,
      [SINGLE_PAYMENT_LINKS_EVENTS_PARAMS.ACTION]: isOpen,
    });
  };

  useEffect(() => {
    setFields((prev: any) => {
      return {
        ...prev,
        ...ADVANCED_OPTIONS_INITIAL_VALUES(t),
      };
    });
  }, []);

  return fullPageStatus.loading ? (
    <SectionLoader {...SINGLE_PL_SECTIONS_DIMENSIONS.ADVANCED_OPTIONS} />
  ) : (
    <div className={styles['advanced-options']}>
      <Accordion
        hasDivider={false}
        type="transparent_box"
        header={
          <p className={styles['advanced-options__title']}>
            {t(
              'innerLayout.paymentLinksCreationPages.singlePaymentLink.sections.advancedOptions.title'
            )}
          </p>
        }
        onAccordionToggle={handleAccordionToggle}
      >
        <div className={styles['advanced-options__content']}>
          <ImageUploader setFields={setFields} />
          <Description fields={fields} setFields={setFields} />
          <ReferenceId fields={fields} setFields={setFields} />
        </div>
      </Accordion>
    </div>
  );
};

export default AdvancedOptions;
